import axios from "axios"
import GatsbyConfig from "../../gatsby-config"

//import { withPrefix } from "gatsby"

// export const getAutofillData = () => {
//   //   let result =
//   return axios
//     .post(withPrefix("/Claim/GetData"), null)
//     .then(function(response) {
//       return response
//     })

//   //   return result
// }

export const apiPostRequest = (url, data, config) => {
  const apiPreFix = GatsbyConfig.siteMetadata.apiPreFix

  let preFix = process.env.NODE_ENV !== "development" ? apiPreFix : ""

  return axios.post(preFix + url, data, config).then(function(response) {
    return response
  })
}
